import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import { ApiService } from "../../services/apiService";

export const fetchReportAnalysis = createAsyncThunk(
  "reportAnalysis/fetchReportAnalysis",
  async (_, { rejectWithValue }) => {
    try {
      const reportAnalysis = await ApiService.get<any>("reports/analytics");
      return reportAnalysis?.data || [];
    } catch (error) {
      return rejectWithValue(
        (error as any).message || "Failed to fetch report analysis"
      );
    }
  }
);

const reportAnalysisSlice = createSlice({
  name: "reportAnalysis",
  initialState: {
    reportAnalysis: {} as any,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReportAnalysis.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchReportAnalysis.fulfilled, (state, action) => {
        state.isLoading = false;
        state.reportAnalysis = action.payload;
      })
      .addCase(fetchReportAnalysis.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default reportAnalysisSlice.reducer;
